<template>
  <div class="login" :class="'login-' + view" :style="{height: height}">
    <div class="modal">
      <div v-if="dingtalkHanded" class="dingtalk-handed">
        <h2>钉钉授权</h2>
        <p>{{ dingtalkHandedText }}</p>
      </div>

      <div v-else-if="view === 'select'" class="identity-select">
        <h2>{{ welcomeText }}</h2>
        <p class="identity-tip">请选择登录身份</p>
        <div class="identity-row">
          <div class="identity-item admin" @click="enterAdmin">
            <Icon type="ios-contact" size="36"></Icon>
            <div class="identity-name">管理员登录</div>
            <div class="identity-desc">使用钉钉授权，或用手机钉钉扫码。确认后在这台电脑登录。</div>
          </div>
          <div class="identity-item agent" @click="enterAgent">
            <Icon type="ios-people" size="36"></Icon>
            <div class="identity-name">代理登录</div>
            <div class="identity-desc">使用账号和密码登录，提交后继续短信验证。</div>
          </div>
        </div>
      </div>

      <div v-else-if="view === 'admin'" class="admin-login">
        <h2 class="admin-title">管理员登录</h2>

        <div v-if="chooseAccounts.length" class="account-choose">
          <p class="view-tip">该钉钉绑定了多个后台账号，请选择要登录的账号</p>
          <div v-for="item in chooseAccounts" :key="item.id" class="account-item"
               :class="{'account-item-disabled': chooseLoading}" @click="chooseLogin(item)">
            <div class="account-name">{{ item.nickname }}</div>
            <div class="account-sub">
              <span>登录账号：{{ item.account }}</span>
              <span>编号：{{ item.id }}</span>
            </div>
          </div>
        </div>

        <template v-else>
          <p class="view-tip">请使用钉钉登录，未绑定钉钉的账号无法登录</p>

          <div class="dingtalk-login">
            <i-button type="primary" long :loading="dingtalkLoginLoading" @click="dingtalkAuthLogin">
              钉钉授权登录
            </i-button>
            <p v-if="dingtalkWaiting" class="dingtalk-open-tip">已打开钉钉，请在钉钉里确认授权，然后回到这个页面</p>
          </div>

          <div class="qr-code">
            <div id="dingtalk-qr"></div>
            <p>使用手机钉钉扫码，确认后在这台电脑登录</p>
          </div>

          <div class="back">
            <a @click="backToSelect">返回身份选择</a>
          </div>
        </template>
      </div>

      <div v-else class="agent-login">
        <h2 class="agent-title">代理登录</h2>
        <p class="view-tip">请使用账号密码登录</p>

        <i-form ref="loginForm" :model="loginForm" :rules="ruleValidate">
          <Form-item prop="mobile">
            <Input v-model="loginForm.mobile" size="large" placeholder="请输入账号"></Input>
          </Form-item>
          <Form-item prop="password">
            <Input type="password" v-model="loginForm.password" size="large" placeholder="请输入密码"
                   @on-enter="submit"></Input>
          </Form-item>
          <Form-item style="margin-bottom: 10px">
            <Checkbox v-model="loginForm.remember">记住密码</Checkbox>
          </Form-item>
          <Form-item>
            <i-button type="success" long @click="submit">提交</i-button>
          </Form-item>
        </i-form>

        <div class="back">
          <a @click="backToSelect">返回身份选择</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted: function () {
    this.height = window.innerHeight + 'px'
    this.resizeHandler = () => {
      this.height = window.innerHeight + 'px'
    }
    window.addEventListener('resize', this.resizeHandler)
    this.ensureMobileViewport()

    if (this.$route.query.backUrl) {
      this.backUrl = this.$route.query.backUrl
    }
    const search = new URLSearchParams(window.location.search)
    const authCode = this.$route.query.authCode || this.$route.query.code || search.get('authCode') || search.get('code')
    const state = this.$route.query.state || search.get('state') || ''
    if (authCode && this.inDingTalk()) {
      this.dingtalkHanded = true
      this.dingtalkHandedText = '正在确认授权…'
      this.dingtalkLogin(authCode, state)
      return
    }
    if (authCode) {
      this.view = 'admin'
      this.dingtalkLogin(authCode, state)
      return
    }
    const pending = window.sessionStorage.getItem('ding_login_state')
    if (pending && this.isMobile() && !this.inDingTalk()) {
      this.view = 'admin'
      this.dingtalkWaiting = true
      this.dingtalkLoginLoading = true
      this.startDingPoll(pending)
    }
  },
  data () {
    return {
      view: 'select',
      backUrl: '/',
      height: '1200px',
      loginForm: {
        mobile: '',
        password: '',
        remember: false
      },
      ruleValidate: {
        mobile: [
          {required: true, message: '账号不能为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: 'blur'}
        ]
      },
      dingtalkLoginUrl: '',
      dingtalkLoginLoading: false,
      dingtalkWaiting: false,
      dingtalkHanded: false,
      dingtalkHandedText: '授权成功，请返回浏览器。登录会在原来的页面完成。',
      chooseAccounts: [],
      choosePickToken: '',
      chooseLoading: false,
      dingPollTimer: null,
      resizeHandler: null,
      loginViewportAdded: false,
      prevViewport: ''
    }
  },
  computed: {
    welcomeText () {
      if (window.location.hostname.indexOf('ququkid.com') > -1) {
        return '欢迎使用趣趣ABC管理系统'
      }
      return '欢迎使用HelloKid学员管理系统'
    }
  },
  methods: {
    enterAdmin () {
      let self = this
      self.view = 'admin'
      self.$nextTick(function () {
        self.loadQrCode()
      })
    },
    enterAgent () {
      this.view = 'agent'
    },
    backToSelect () {
      this.view = 'select'
    },
    submit () {
      var self = this
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          self.$http.post('/adminUser/doLogin', self.loginForm).then(function (res) {
            if (res && res.data) {
              self.$store.set('mobile', res.data.mobile)
              self.$store.set('_account', res.data.account)
              self.$router.push('/LoginSms')
            }
          })
        }
      })
    },
    redirectUri () {
      return window.location.origin
    },
    qrSize () {
      let width = window.innerWidth || 360
      if (width < 480) {
        return Math.max(200, Math.min(260, width - 72))
      }
      return 280
    },
    ensureMobileViewport () {
      let meta = document.querySelector('meta[name="viewport"]')
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', 'viewport')
        meta.setAttribute('data-login-viewport', '1')
        document.head.appendChild(meta)
        this.loginViewportAdded = true
      }
      this.prevViewport = meta.getAttribute('content')
      meta.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover')
    },
    restoreViewport () {
      let meta = document.querySelector('meta[name="viewport"]')
      if (!meta) {
        return
      }
      if (this.loginViewportAdded) {
        meta.parentNode.removeChild(meta)
        return
      }
      if (this.prevViewport) {
        meta.setAttribute('content', this.prevViewport)
      }
    },
    loadLoginUrl (callback) {
      let self = this
      if (self.dingtalkLoginUrl) {
        callback(self.dingtalkLoginUrl)
        return
      }
      self.$http.get('/adminUser/dingtalk-login-link', {params: {redirectUri: self.redirectUri()}}).then(function (res) {
        if (res && res.data) {
          self.dingtalkLoginUrl = res.data
          callback(res.data)
        } else {
          callback('')
        }
      })
    },
    loadQrCode () {
      let self = this
      self.loadLoginUrl(function (url) {
        if (!url || self.view !== 'admin') {
          return
        }
        let clientId = ''
        try {
          clientId = new URL(url).searchParams.get('client_id')
        } catch (e) {
          clientId = ''
        }
        if (!clientId) {
          self.$Message.error('钉钉登录配置缺失')
          return
        }
        self.ensureDingLoginScript(function () {
          if (self.view !== 'admin' || !document.getElementById('dingtalk-qr')) {
            return
          }
          if (!window.DTFrameLogin) {
            self.$Message.error('钉钉扫码组件加载失败')
            return
          }
          let qrSize = self.qrSize()
          window.DTFrameLogin(
            {id: 'dingtalk-qr', width: qrSize, height: qrSize},
            {
              redirect_uri: encodeURIComponent(self.redirectUri()),
              client_id: clientId,
              scope: 'openid',
              response_type: 'code',
              state: 'bops',
              prompt: 'consent'
            },
            function (loginResult) {
              let authCode = loginResult && (loginResult.authCode || loginResult.code)
              if (authCode) {
                self.dingtalkLogin(authCode)
              }
            },
            function (errorMsg) {
              self.$Message.error(errorMsg || '钉钉扫码失败')
            }
          )
        })
      })
    },
    ensureDingLoginScript (callback) {
      if (window.DTFrameLogin) {
        callback()
        return
      }
      let script = document.createElement('script')
      script.src = 'https://g.alicdn.com/dingding/h5-dingtalk-login/0.21.0/ddlogin.js'
      script.onload = function () {
        callback()
      }
      script.onerror = function () {
        callback()
      }
      document.body.appendChild(script)
    },
    isMobile () {
      return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    },
    inDingTalk () {
      return /DingTalk/i.test(navigator.userAgent)
    },
    randomState () {
      let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let out = ''
      for (let i = 0; i < 32; i++) {
        out += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return out
    },
    dingtalkAuthLogin () {
      let self = this
      let popup = null
      if (self.isMobile() && !self.inDingTalk()) {
        popup = window.open('about:blank', '_blank')
      }
      self.dingtalkLoginLoading = true
      self.loadLoginUrl(function (url) {
        if (!url) {
          self.dingtalkLoginLoading = false
          if (popup) {
            popup.close()
          }
          return
        }
        if (!self.isMobile() || self.inDingTalk()) {
          if (popup) {
            popup.close()
          }
          window.location.href = url
          return
        }
        let state = self.randomState()
        window.sessionStorage.setItem('ding_login_state', state)
        let oauth = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'state=' + encodeURIComponent(state)
        self.dingtalkWaiting = true
        self.startDingPoll(state)
        if (popup) {
          popup.location.href = oauth
        } else {
          window.location.href = oauth
        }
      })
    },
    startDingPoll (state) {
      let self = this
      self.stopDingPoll()
      let n = 0
      self.dingPollTimer = setInterval(function () {
        n++
        if (n > 60) {
          self.stopDingPoll()
          self.dingtalkWaiting = false
          self.dingtalkLoginLoading = false
          window.sessionStorage.removeItem('ding_login_state')
          self.$Message.error('等待钉钉授权超时，请重试')
          return
        }
        self.$http.get('/adminUser/dingtalk-login-poll', {params: {state: state}}).then(function (res) {
          if (!(res && res.status === 'ok' && res.data)) {
            return
          }
          let data = res.data
          if (data.error) {
            self.stopDingPoll()
            self.dingtalkWaiting = false
            self.dingtalkLoginLoading = false
            window.sessionStorage.removeItem('ding_login_state')
            self.$Message.error(data.error)
            return
          }
          if (data.choose === true) {
            self.stopDingPoll()
            self.dingtalkWaiting = false
            self.dingtalkLoginLoading = false
            window.sessionStorage.removeItem('ding_login_state')
            self.showChoose(data)
            return
          }
          if (data.token) {
            self.stopDingPoll()
            self.dingtalkWaiting = false
            self.dingtalkLoginLoading = false
            window.sessionStorage.removeItem('ding_login_state')
            self.finishLogin(data)
          }
        })
      }, 2000)
    },
    stopDingPoll () {
      if (this.dingPollTimer) {
        clearInterval(this.dingPollTimer)
        this.dingPollTimer = null
      }
    },
    dingtalkLogin (authCode, state) {
      let self = this
      let insideDing = self.inDingTalk()
      self.$http.post('/adminUser/dingtalkScanLogin', {
        authCode: authCode,
        redirectUri: self.redirectUri(),
        state: insideDing ? (state || '') : ''
      }).then(function (res) {
        if (!(res && res.data)) {
          if (insideDing) {
            self.dingtalkHandedText = '授权失败，请回到浏览器重试'
          }
          return
        }
        if (insideDing && state) {
          self.dingtalkHanded = true
          self.dingtalkHandedText = '授权成功，请返回浏览器。登录会在原来的页面完成。'
          if (window.location.search) {
            window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash)
          }
          return
        }
        if (res.data.choose === true) {
          self.showChoose(res.data)
          return
        }
        self.finishLogin(res.data)
      }, function () {
        if (insideDing) {
          self.dingtalkHandedText = '授权失败，请回到浏览器重试'
        }
      })
    },
    showChoose (data) {
      this.choosePickToken = data.pickToken || ''
      this.chooseAccounts = data.accounts || []
    },
    chooseLogin (item) {
      let self = this
      if (self.chooseLoading) {
        return
      }
      if (!self.choosePickToken) {
        self.$Message.error('登录信息已失效，请重新钉钉登录')
        return
      }
      self.chooseLoading = true
      self.$http.post('/adminUser/dingtalkChooseLogin', {
        pickToken: self.choosePickToken,
        adminUserId: item.id
      }).then(function (res) {
        self.chooseLoading = false
        if (res && res.status === 'ok' && res.data && res.data.token) {
          self.chooseAccounts = []
          self.choosePickToken = ''
          self.finishLogin(res.data)
        }
      }, function () {
        self.chooseLoading = false
      })
    },
    finishLogin (data) {
      let self = this
      self.$store.set('token', data.token)
      self.$store.set('mobile', data.account)
      self.$store.set('id', data.id)
      self.$store.set('permissions', data.permissions)
      self.$store.set('adminRule', data.adminRule)
      if (data.adviserInfo) {
        self.$store.set('adviserInfo', data.adviserInfo)
      }
      self.$Message.success('登录成功!')
      if (window.location.search) {
        window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash)
      }
      if (self.backUrl.indexOf('login') > -1) {
        self.$router.push('/')
      } else {
        self.$router.push(self.backUrl)
      }
    }
  },
  beforeDestroy () {
    this.stopDingPoll()
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    this.restoreViewport()
  }
}
</script>

<style scoped lang="less">
.login {
  min-height: 100vh;
  text-align: center;
  padding: 72px 24px 48px;
  background: #eef2f6;

  .modal {
    margin: 0 auto;
    padding: 36px 32px 28px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 12px 40px rgba(23, 43, 77, .12);

    h2 {
      margin: 0 auto 8px;
      font-size: 26px;
      font-weight: 600;
      color: #17233d;
    }

    form {
      text-align: left;
    }
  }

  .identity-tip,
  .view-tip {
    margin: 0 0 28px;
    color: #808695;
    font-size: 14px;
  }

  .identity-select .modal,
  &.login-select .modal {
    width: 760px;
  }

  .identity-row {
    display: flex;
    justify-content: center;
    gap: 20px;
    text-align: left;
  }

  .identity-item {
    flex: 1;
    min-height: 180px;
    padding: 28px 24px;
    border-radius: 12px;
    cursor: pointer;
    color: #fff;
    transition: transform .15s ease, box-shadow .15s ease;

    .identity-name {
      margin-top: 16px;
      font-size: 22px;
      font-weight: 600;
    }

    .identity-desc {
      margin-top: 8px;
      font-size: 14px;
      line-height: 1.6;
      opacity: .92;
    }

    &.admin {
      background: linear-gradient(160deg, #1677ff 0%, #0958d9 100%);
    }

    &.agent {
      background: linear-gradient(160deg, #13a36a 0%, #0b7a4b 100%);
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 10px 24px rgba(23, 43, 77, .18);
    }
  }

  &.login-admin .modal,
  &.login-agent .modal {
    width: 420px;
  }

  .admin-title {
    color: #0958d9;
  }

  .agent-title {
    color: #0b7a4b;
  }

  .admin-login {
    border-top: 4px solid #1677ff;
    margin: -36px -32px 0;
    padding: 32px 32px 0;
  }

  .agent-login {
    border-top: 4px solid #13a36a;
    margin: -36px -32px 0;
    padding: 32px 32px 0;
  }

  .dingtalk-login {
    margin-top: 8px;
  }

  .account-choose {
    margin-top: 8px;
    text-align: left;

    .view-tip {
      text-align: center;
    }
  }

  .account-item {
    margin-bottom: 12px;
    padding: 14px 16px;
    border: 1px solid #dcdee2;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:hover {
      border-color: #1677ff;
      box-shadow: 0 6px 16px rgba(22, 119, 255, .14);
    }

    .account-name {
      font-size: 16px;
      font-weight: 600;
      color: #17233d;
    }

    .account-sub {
      margin-top: 6px;
      font-size: 13px;
      color: #808695;

      span {
        margin-right: 16px;
      }
    }
  }

  .account-item-disabled {
    cursor: default;
    opacity: .6;
  }

  .dingtalk-open-tip,
  .dingtalk-handed p {
    margin: 12px 0 0;
    font-size: 14px;
    line-height: 1.6;
    color: #515a6e;
  }

  .dingtalk-handed h2 {
    margin: 0;
    font-size: 22px;
    color: #17233d;
  }

  .qr-code {
    margin-top: 20px;
    padding-top: 8px;

    #dingtalk-qr {
      width: 280px;
      height: 280px;
      margin: 0 auto;
    }

    p {
      margin-top: 8px;
      font-size: 13px;
      color: #808695;
    }
  }

  .back {
    margin-top: 20px;
    font-size: 14px;

    a {
      color: #808695;
      cursor: pointer;

      &:hover {
        color: #1677ff;
      }
    }
  }
}

@media (max-width: 720px) {
  .login {
    padding: 24px 12px 32px;

    .modal {
      width: 100% !important;
      max-width: 100%;
      padding: 24px 16px 20px;
      border-radius: 12px;
      box-sizing: border-box;
    }

    .identity-row {
      flex-direction: column;
    }

    .identity-item {
      min-height: 0;
      padding: 20px 16px;

      .identity-name {
        margin-top: 10px;
        font-size: 18px;
      }
    }

    .admin-login,
    .agent-login {
      margin: -24px -16px 0;
      padding: 20px 16px 0;
    }

    .qr-code #dingtalk-qr {
      width: 100%;
      max-width: 260px;
      height: auto;
      min-height: 220px;
    }

    .back a {
      display: inline-block;
      padding: 8px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?31c594b6